<form (submit)="formSubmit.emit($event)">
  <div
    *ngIf="tenant"
    class="tenant-general-internal-data-section"
    [ngClass]="{
      'tenant-general-internal-data-section--editing': !readMode
    }"
  >
    <p class="tenant-general-internal-data-label">
      {{ 'tenantConfiguration.general.internalData' | translate }}
    </p>
    <p>
      {{ 'tenantConfiguration.general.aaptivId' | translate }}: {{ tenant.id }}
    </p>
    @if (tenant.externalPearTenantId) {
    <p>Pear Id: {{ tenant.externalPearTenantId }}</p>
    }
    <p>Created: {{ tenant.created }}</p>
    <p>Updated: {{ tenant.updated }}</p>
  </div>
  <div class="tenant-general-info">
    <app-text-input
      class="tenant-general-name"
      [(value)]="name"
      label="{{ 'common.name' | translate }}"
      [error]="!!nameError()"
      errorMessage="{{ nameError() }}"
      [size]="InputSize.MEDIUM"
      [width]="InputWidth.FULL"
      [direction]="InputDirection.HORIZONTAL"
      [spacingBottom]="InputFieldSpacing.NONE"
      [variant]="InputVariant.OUTLINE"
      [disabled]="readMode"
      data-test-id="tenant-general-name-input"
    ></app-text-input>
    <app-text-input
      class="tenant-general-name"
      [(value)]="description"
      label="{{ 'common.description' | translate }}"
      [error]="!!descriptionError()"
      errorMessage="{{ descriptionError() }}"
      [type]="InputType.DESCRIPTION"
      [width]="InputWidth.FULL"
      [direction]="InputDirection.HORIZONTAL"
      [spacingBottom]="InputFieldSpacing.NONE"
      [variant]="InputVariant.OUTLINE"
      [disabled]="readMode"
      data-test-id="tenant-general-description-input"
    ></app-text-input>
  </div>
  <div class="tenant-general-onboarding">
    <h2 class="section-title">Onboarding</h2>
    <app-text-input
      class="tenant-general-slugs"
      [(value)]="slugs"
      label="{{ 'common.slugs' | translate }}"
      [error]="!!slugsError()"
      errorMessage="{{ slugsError() }}"
      [size]="InputSize.MEDIUM"
      [width]="InputWidth.FULL"
      [direction]="InputDirection.HORIZONTAL"
      [spacingBottom]="InputFieldSpacing.NONE"
      [variant]="InputVariant.OUTLINE"
      [disabled]="readMode"
      data-test-id="tenant-general-slugs-input"
    ></app-text-input>
    @if(provisioningType() === ProvisioningTypes.emailRegex) {
    <app-text-input
      class="tenant-general-emails"
      [(value)]="emails"
      label="{{ 'common.emails' | translate }}"
      [error]="!!emailsError()"
      errorMessage="{{ emailsError() }}"
      [size]="InputSize.MEDIUM"
      [width]="InputWidth.FULL"
      [direction]="InputDirection.HORIZONTAL"
      [spacingBottom]="InputFieldSpacing.NONE"
      [variant]="InputVariant.OUTLINE"
      [disabled]="readMode"
      data-test-id="tenant-general-emails-input"
    ></app-text-input>
    }
    <div class="tenant-general-tenant-select-group">
      <div class="field-group">
        <p class="label">
          {{ 'tenantConfiguration.general.provisioningType' | translate }}
        </p>
        <app-select-dropdown
          [options]="provisioningTypes"
          [(selected)]="provisioningType"
          [disabled]="readMode"
          (handleSelect)="handleProvisioningType($event)"
          height="small"
        ></app-select-dropdown>
      </div>
    </div>
  </div>
</form>
